export default __webpack_public_path__ + "static/media/CV Cristian Buciu.29648477.pdf";